import type { CustomIconProps } from '../CustomIcon';

export const DocumentShareIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  unfilled,
  ...props
}: CustomIconProps) => {
  return (
    <svg width={size} height={size * 1.16} viewBox='0 0 24 28' fill='none' {...props}>
      <g clipPath='url(#clip0_10593_21701)'>
        <rect width='24' height='24' transform='translate(0 4)' fill='white' />
        <path
          d='M15 6H6C5.46957 6 4.96086 6.21071 4.58579 6.58579C4.21071 6.96086 4 7.46957 4 8V24C4 24.5304 4.21071 25.0391 4.58579 25.4142C4.96086 25.7893 5.46957 26 6 26H18C18.5304 26 19.0391 25.7893 19.4142 25.4142C19.7893 25.0391 20 24.5304 20 24V11L15 6Z'
          fill={color}
          stroke={color}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <mask
          id='path-2-outside-1_10593_21701'
          maskUnits='userSpaceOnUse'
          x='14'
          y='4'
          width='8'
          height='8'
          fill='black'>
          <rect fill='#FFFFFF' x='14' y='4' width='8' height='8' />
          <path d='M16 6V10H20' />
        </mask>
        <path d='M16 6V10H20' fill={color} />
        <path
          d='M16.5303 5.46967C16.2374 5.17678 15.7626 5.17678 15.4697 5.46967C15.1768 5.76256 15.1768 6.23744 15.4697 6.53033L16.5303 5.46967ZM19.4697 10.5303C19.7626 10.8232 20.2374 10.8232 20.5303 10.5303C20.8232 10.2374 20.8232 9.76256 20.5303 9.46967L19.4697 10.5303ZM15.4697 6.53033L19.4697 10.5303L20.5303 9.46967L16.5303 5.46967L15.4697 6.53033ZM17.5 6C17.5 5.17157 16.8284 4.5 16 4.5C15.1716 4.5 14.5 5.17157 14.5 6H17.5ZM16 10H14.5C14.5 10.8284 15.1716 11.5 16 11.5V10ZM20 11.5C20.8284 11.5 21.5 10.8284 21.5 10C21.5 9.17157 20.8284 8.5 20 8.5V11.5ZM14.5 6V10H17.5V6H14.5ZM16 11.5H20V8.5H16V11.5Z'
          fill='white'
          mask='url(#path-2-outside-1_10593_21701)'
        />
        <path
          d='M8.5 17H15M15 17L13 15M15 17L13 19'
          stroke={secondaryColor}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M13.5 21.5H7M7 21.5L9 19.5M7 21.5L9 23.5'
          stroke={secondaryColor}
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_10593_21701'>
          <rect width='24' height='24' fill='white' transform='translate(0 4)' />
        </clipPath>
      </defs>
    </svg>
  );
};
